/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Protocol_Copy_LinkInputs */

const cs_tasks_protocol_copy_link = /** @type {(inputs: Tasks_Protocol_Copy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopírovat odkaz`)
};

const en_tasks_protocol_copy_link = /** @type {(inputs: Tasks_Protocol_Copy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy link`)
};

/**
* | output |
* | --- |
* | "Copy link" |
*
* @param {Tasks_Protocol_Copy_LinkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_protocol_copy_link = /** @type {((inputs?: Tasks_Protocol_Copy_LinkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Protocol_Copy_LinkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_protocol_copy_link(inputs)
	return cs_tasks_protocol_copy_link(inputs)
});